// extracted by mini-css-extract-plugin
export var standaloneTable = "_fs-0";
export var withExtraHeader = "_fs-1";